export default "__VITE_PUBLIC_ASSET__7a6198f6__"